import React from "react";
import Svg, { Path, Circle, G } from "react-native-svg";
import AppTheme from "../../../AppTheme";

export default function CheckedIcon({ size }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8076 21.6152C4.88916 21.6152 0 16.7261 0 10.8076C0 4.88916 4.88086 0 10.7993 0C16.7178 0 21.6152 4.88916 21.6152 10.8076C21.6152 16.7261 16.7261 21.6152 10.8076 21.6152ZM9.47949 16.2363C9.78662 16.2363 10.0522 16.0952 10.2515 15.7881L15.8296 7.04736C15.9541 6.86475 16.062 6.64062 16.062 6.44141C16.062 6.00146 15.6719 5.72754 15.2651 5.72754C15.0244 5.72754 14.7837 5.86865 14.6011 6.15088L9.43799 14.3604L6.69043 10.9155C6.47461 10.6416 6.25049 10.542 5.98486 10.542C5.57812 10.542 5.23779 10.8657 5.23779 11.3057C5.23779 11.5132 5.3208 11.7373 5.46191 11.9116L8.66602 15.7964C8.92334 16.1118 9.17236 16.2363 9.47949 16.2363Z"
        fill={AppTheme.DEFAULT_COLOR}
      />
    </Svg>
  );
}
